import i18n from '@/config/i18n'
import { DeliveryFrequency } from '@/types/generated/graphql'

type Formatter = (value: DeliveryFrequency | string) => string

const formatDeliveryFrequency: Formatter = (value) => {
  switch (value) {
    case '1':
    case DeliveryFrequency.EveryWeek:
      return i18n.tc('enums.deliveryfrequency.everyweek')
    case '2':
    case DeliveryFrequency.EveryOtherWeek:
      return i18n.tc('enums.deliveryfrequency.everyotherweek')
    default:
      return i18n.tc('enums.unknown')
  }
}

export default formatDeliveryFrequency
